// extracted by mini-css-extract-plugin
export default {"episode":"EpisodeDetails_episode__qaGeB","episode__name":"EpisodeDetails_episode__name__nfX0w","episode__date":"EpisodeDetails_episode__date__uD0VG"};